import WorklistMonitor from 'app/dicom/WorklistMonitor';
import React from 'react';

const WorklistMonitorContext = React.createContext<WorklistMonitor>(undefined);
export default WorklistMonitorContext;
